<script setup lang="ts">
import LeButton from "@dsk/components/Button/LeButton.vue";
import LeCheckbox from "@dsk/components/Checkbox/LeCheckbox.vue";
import LeHeading from "@dsk/components/Heading/LeHeading.vue";
import LeModal from "@dsk/components/LeModal.vue";
import type { ModalProps } from "@dsk/types";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

import { useAppLink } from "@/composables";
import { config } from "@/config";

defineProps<ModalProps>();

const emit = defineEmits<{
  close: [];
}>();

const { t } = useI18n();
const { op5MsiLink } = useAppLink();
const { language } = config.app;

const hasAcceptedTerms = ref<boolean>(false);

const onClose = () => {
  emit("close");
};
</script>

<template>
  <LeModal class="le-msi-download-modal" :is-open="isOpen" @close="onClose()">
    <template #title>
      <LeHeading tag="h2" size="m">{{ t("le-download.modal.title") }}</LeHeading>
    </template>

    <template #body>
      <div class="le-msi-download-modal__body">
        <p>{{ t("le-download.modal.text") }}</p>

        <label class="le-msi-download-modal__terms">
          <LeCheckbox v-model="hasAcceptedTerms" />
          <i18n-t tag="span" keypath="le-download.modal.accept-terms.text">
            <template #termsLink>
              <a :href="`/${language}/terms`" target="_blank" class="le-msi-download-modal__terms-link">
                {{ t("le-download.modal.accept-terms.link") }}
              </a>
            </template>
          </i18n-t>
        </label>
      </div>
    </template>

    <template #buttons>
      <LeButton variant="outline" @click="onClose()">{{ t("le-download.modal.button.cancel") }}</LeButton>
      <LeButton tag="a" :href="op5MsiLink" target="_blank" :disabled="!hasAcceptedTerms" @click="onClose()">
        {{ t("le-download.modal.button.submit") }}
      </LeButton>
    </template>
  </LeModal>
</template>

<style lang="less" scoped>
@import "@dsk/styles/all.less";

.le-msi-download-modal {
  &__terms {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
  }

  &__terms-link {
    .body-text("m");
    .link();
  }
}
</style>
